import React from "react"

import { PrimitiveButton } from "@/primitives/PrimitiveButton"
import { ButtonProps } from "@/components/Button/protocols"

import useStyles from "@/components/Button/styles"

export const Primary = ({
	children,
	...props
}: ButtonProps): React.ReactElement => {
	const classes = useStyles()

	return (
		<PrimitiveButton
			sx={[classes.button, classes.primary]}
			variant="contained"
			{...props}
		>
			{children}
		</PrimitiveButton>
	)
}